<template>
  <v-text-field v-model="val" outlined hide-details="auto" v-bind="{...input, ...$attrs}" ></v-text-field>
</template>

<script>
  export default {
   props: ['value', 'input'],
   computed: {
		val: {
			get() { return this.value },
			set(v) { this.$emit('input', v) }
		}
	},
  };
</script>
